import { ExternalLink, MessageSquare, Edit3, Hash } from "lucide-react";

export function getSourceIcon(sourceType: string) {
  switch (sourceType) {
    case "url":
      return <ExternalLink className="size-4" />;
    case "message":
      return <MessageSquare className="size-4" />;
    case "discord_forum":
      return <Hash className="size-4" />;
    case "direct":
    default:
      return <Edit3 className="size-4" />;
  }
}

export function getSourceLabel(sourceType: string) {
  switch (sourceType) {
    case "url":
      return "URL";
    case "message":
      return "Discord";
    case "discord_forum":
      return "Forum";
    case "direct":
    default:
      return "Manual";
  }
}
